import config from '../../config'

const getExternalNotams = () => ({
  method: 'get',
  url: `${config.baseUrl}/Notams`,
})

export default getExternalNotams
